import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import WorkSelect from './work-select'
import {
  getWorksList,
  getWorksCount,
  getSelectedWorkId
} from '../../../../../../stores/works/works.selectors'
import {
  selectWork,
  setMedia
} from '../../../../../../stores/works/works.actions'

const mapStateToProps = (state, { match }) => {
  const works = getWorksList(state)
  const selectedWorkdId = getSelectedWorkId(state)
  return {
    works,
    count: getWorksCount(state),
    selectedWorkId: selectedWorkdId ? selectedWorkdId : match.params.workId
  }
}

const mapDispatchToProps = dispatch => ({
  onSelect: id => {
    dispatch(setMedia(0))
    return dispatch(selectWork(id))
  }
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(WorkSelect)
)
